import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxAllowanceDetailsComponent } from './tax-allowance-details/feature-tax-allowance-details.component';
import { BerekeningComponent } from './toeslagen/berekening/berekening.component';
import { SharedUiOffCanvasModule } from '@snelstart/ui-off-canvas';
import { HuurtoeslagComponent } from './toeslagen/huurtoeslag/huurtoeslag.component';
import { KinderopvangtoeslagComponent } from './toeslagen/kinderopvangtoeslag/kinderopvangtoeslag.component';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { KinderenComponent } from './toeslagen/kinderen/kinderen.component';
import { InkomenComponent } from './toeslagen/inkomen/inkomen.component';
import { VoorschotComponent } from './toeslagen/voorschot/voorschot.component';
import { PartnerComponent } from './toeslagen/partner/partner.component';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { TekstAanvragerComponent } from './toeslagen/toelichtigen-tekst/tekst-aanvrager/tekst-aanvrager.component';
import { TekstPartnerComponent } from './toeslagen/toelichtigen-tekst/tekst-partner/tekst-partner.component';
import { TekstKinderenComponent } from './toeslagen/toelichtigen-tekst/tekst-kinderen/tekst-kinderen.component';
import {
  TekstKinderopvangComponent
} from './toeslagen/toelichtigen-tekst/tekst-kinderopvang/tekst-kinderopvang.component';
import {
  TekstHuurtoeslagComponent
} from './toeslagen/toelichtigen-tekst/tekst-huurtoeslag/tekst-huurtoeslag.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiOffCanvasModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiAlertModule,
    TekstAanvragerComponent,
    TekstPartnerComponent,
    TekstKinderenComponent,
    TekstKinderopvangComponent,
    TekstHuurtoeslagComponent,
    FeatureTaxAllowanceDetailsComponent,
    BerekeningComponent,
    HuurtoeslagComponent,
    KinderopvangtoeslagComponent,
    KinderenComponent,
    InkomenComponent,
    VoorschotComponent,
    PartnerComponent
  ],
  declarations: [],
  exports: [FeatureTaxAllowanceDetailsComponent]
})
export class FeatureTaxAllowanceDetailsModule {
}
